
import Vue from 'vue';

export interface ItemSorted<T> {
  moved: { element: T; newIndex: number; oldIndex: number };
}

export default Vue.extend({
  props: {
    sortItemHandler: {
      type: Function,
      required: true,
    },
  },
  data() {
    return { indexPositionMap: {} };
  },
  watch: {
    'cvCvSection.sectionItems'() {
      // NOTE:
      // cvCvSection.sectionItems will be updated in vuedraggable
      // then it's necessary to wait for cvCvSection.sectionItems be refreshed
      this.$nextTick(function() {
        this.updateItemIndexPositionMap();
      });
    },
  },
  mounted() {
    this.updateItemIndexPositionMap();
  },
  methods: {
    async onItemSorted({ moved }: ItemSorted<any>) {
      const newPosition = this.indexPositionMap[moved.newIndex];
      await this.sortItemHandler(moved.element, newPosition);
      this.updateItemIndexPositionMap();
    },
    updateItemIndexPositionMap() {
      this.indexPositionMap = this.sectionItems.reduce((r, item, index) => {
        r[index] = item.position;
        return r;
      }, {});
    },
  },
});
